const TrashIconSVG = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.17871 5H4.67871H16.6787"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.1787 5V15.5C15.1787 15.8978 15.0207 16.2794 14.7394 16.5607C14.4581 16.842 14.0765 17 13.6787 17H6.17871C5.78089 17 5.39936 16.842 5.11805 16.5607C4.83675 16.2794 4.67871 15.8978 4.67871 15.5V5M6.92871 5V3.5C6.92871 3.10218 7.08675 2.72064 7.36805 2.43934C7.64936 2.15804 8.03089 2 8.42871 2H11.4287C11.8265 2 12.2081 2.15804 12.4894 2.43934C12.7707 2.72064 12.9287 3.10218 12.9287 3.5V5"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.42871 8.75V13.25"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.4287 8.75V13.25"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default TrashIconSVG;
